import {
    SelectedActionTypes,
    ChangeBackgroundSelectedActionType,
    ChangeLabelSelectedActionType,
    ChangeInputSelectedActionType,
    ChangeInputValueSelectedActionType,
    ChangeChoicesSelectedActionType,
    ChnageSelectedItemActionType,
} from "./types";
import { ActionCreator } from "./../types/store-types";

export const changeBackgroundSelected: ActionCreator<ChangeBackgroundSelectedActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_BACKGROUND_SELECTED,
    payload,
});

export const changeLabelSelected: ActionCreator<ChangeLabelSelectedActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_LABEL_SELECTED,
    payload,
});

export const changeInputSelected: ActionCreator<ChangeInputSelectedActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_INPUT_SELECTED,
    payload,
});

export const changeInputValueSelected: ActionCreator<ChangeInputValueSelectedActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_INPUT_VALUE_SELECTED,
    payload,
});

export const changeChoicesSelected: ActionCreator<ChangeChoicesSelectedActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_CHOICES_SELECTED,
    payload,
});

export const changeSelectedItem: ActionCreator<ChnageSelectedItemActionType> = payload => ({
    type: SelectedActionTypes.CHANGE_SELECTED_ITEM,
    payload,
});
